import React, { useState, useEffect, useContext } from "react";
import AuthUserContext from "./auth-user-context";
import PartnerContext from "./partner-context";
import queryString from "query-string";

import Login from "./login";
import AutoLogin from "./autologin";

const LoginCheck = () => {
  const [queryParams, setQueryParams] = useState({});

  const authUser = useContext(AuthUserContext);
  //console.log("LoginCheck - authUser: ", authUser);
  const origin = useContext(PartnerContext);
  //console.log("LoginCheck -> origin: ", origin);

  useEffect(() => {
    // if (window.location.search) {
    //   const queryParams = queryString.parse(window.location.search);
    //   console.log("LoginCheck - queryParams: ", JSON.stringify(queryParams));

    //   const qp = {};
    //   qp.program_id = queryParams.program_id || "";
    //   qp.user_id = queryParams.user_id || "";
    //   setQueryParams(queryParams);
    //   localStorage.setItem("qp", JSON.stringify(qp));
    // }
    const tmp = window.location.href.split("?"); //returns an array splitting the string before and after "?"
    const queryParams = queryString.parse(tmp[1]); //get position 1 in array for query string
    if (queryParams) {
      //console.log("LoginCheck - queryParams: ", JSON.stringify(queryParams));

      const qp = {};
      qp.program_id = queryParams.program_id || "";
      qp.user_id = queryParams.user_id || "";
      setQueryParams(queryParams);
      localStorage.setItem("qp", JSON.stringify(qp));
    }
  }, []);

  return (
    <div>
      {/* {authUser ? (
        <AutoLogin authUser={authUser} />
      ) : (
        <Login queryParams={queryParams} origin={origin} />
      )} */}
      {origin && origin === "partner" ? (
        <Login queryParams={queryParams} origin={origin} />
      ) : authUser && origin === "home" ? (
        <AutoLogin authUser={authUser} />
      ) : (
        <Login queryParams={queryParams} origin={origin} />
      )}
    </div>
  );
};

export default LoginCheck;
